import React, { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { NAV_LINKS, PHONE } from "../mock";

const Header = () => {
  const [open, setOpen] = useState(false);

  const handleNav = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="dhs-header">
      <div className="dhs-container dhs-header-inner">
        <a href="#home" className="dhs-header-logo" onClick={(e) => handleNav(e, "#home")}>
          <img src="/dans-logo.png" alt="Dan's Handyman Services" className="dhs-header-logo-img" />
          <img src="/dans-mascot.png" alt="" className="dhs-header-mascot" />
        </a>

        <nav className="dhs-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="dhs-nav-link"
              onClick={(e) => handleNav(e, link.href)}
            >
              {link.label}
            </a>
          ))}
          <a href={`tel:${PHONE}`} className="dhs-phone-btn">
            {PHONE}
          </a>
        </nav>

        <button
          className="dhs-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="dhs-mobile-nav">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="dhs-mobile-link"
              onClick={(e) => handleNav(e, link.href)}
            >
              {link.label}
            </a>
          ))}
          <a href={`tel:${PHONE}`} className="dhs-phone-btn dhs-phone-btn-mobile">
            <Phone size={16} /> {PHONE}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
